<template>
    <div :class="'attribute-popover' + (bindings.showEditIcon ? ' attribute-popover-has-icon' : '') + (bindings.highlightOnHover ? ' attribute-highlight-on-hover' : '')"
         @click="bindings.highlightOnHover && !disabled ? $refs.dropdown.open() : ''">
        <slot />
        <ui-icon-button 
            v-if="!disabled && bindings.showEditIcon"
            size="small" 
            icon="edit" 
            class="attribute-popover-icon"
        />
        <component
                :is="component"
                :title="bindings.label"
                :size="size"
                ref="dropdown"
                :class="'custom-popover custom-popover-size-' + bindings.size + ' arrow'"
                :constrain-to-scroll-parent="false"
                :close-on-external-click="false"
                open-on="manual"
                :close-on-scroll="false"
                @hide="$emit('hide')"
            >
                <div v-if="isPopover" :class="(isPopover ? 'popover-inner' : '')">
                    <div class="title">{{ bindings.label }}</div v-if="isPopover">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col">
                                <slot name="controls" />
                            </div>
                        </div>
                        <div v-if="isPopover" class="row">
                            <div class="col">
                                <ui-button size="small" color="primary" @click="$emit('save')" :loading="bindings.isSaving" :disabled="!bindings.canSave">Save</ui-button>
                                <ui-button size="small" @click="$emit('cancel')" :disabled="bindings.isSaving">Cancel</ui-button>
                            </div>
                        </div>
                    </div>
                </div>

                <slot v-if="!isPopover" name="controls" />

                <div v-if="!isPopover" slot="footer" style="width:100%;">
                    <div class="container-fluid" style="padding: 0;">
                        <div class="row">
                            <div class="col">
                                <slot name="footer-left" />
                            </div>
                            <div class="col text-right">
                                <ui-button
                                        size="small"
                                        color="primary"
                                        @click="$emit('save')"
                                        :loading="bindings.isSaving"
                                >Save</ui-button>
                                <ui-button
                                        size="small"
                                        @click="$emit('cancel')"
                                        :disabled="bindings.isSaving"
                                >Cancel</ui-button>
                            </div>
                        </div>
                    </div>
                </div>
        </component>
    </div>
</template>

<style lang="scss">
    .attribute-popover {
        position: relative;
        display: inline-block;
        border-radius: 3px;
        cursor: pointer;

        &.attribute-highlight-on-hover {
            &:hover { background: #f6f6f6; }
        }

        &.attribute-popover-has-icon {
            padding-right: 3.5rem;

            .attribute-popover-icon {
                display: none;
                position: absolute;
                right: .5rem;
                top: 50%;
                transform: translateY(-50%);
            }

            &:hover .attribute-popover-icon { display: block; }
        }
    }
</style>

<script>
    import { UiPopover, UiModal } from 'keen-ui/src/index'

    export default {
        props: {
            bindings: {
                type: Object,
                required: true
            },
            size: {
                type: String
            },
            type: {
                type: String,
                default: 'popover'
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            component() {
                if (this.isPopover) {
                    return UiPopover
                }

                return UiModal
            },
            isPopover() {
                return this.type === 'popover'
            }
        },
        methods: {
            close() {
                this.$refs.dropdown.close()
            }
        }
    }
</script>